import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of, tap } from 'rxjs';
import { CustomerService } from '../../../../common/data-access/api-client/src';
import { CustomerVerificationService } from './customer-verification.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerOrderPageGuard implements CanActivate {
  invalidCodeErrorMsg = 'Ungültiger Code. Bitte versuchen Sie es erneut';
  invalidLinkErrorMsg = 'Unautorisierter Zugriff. Bitte versuchen Sie es später erneut.'

  constructor(
    private customerVerificationService: CustomerVerificationService,
    private customerService: CustomerService, private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const offerId = route.queryParamMap.get('offerId');
    const accessCode = route.queryParamMap.get('accessCode');

    if (!offerId || !accessCode) {
      console.warn("Invalid access link!")
      this.redirectUnauthorizePage(this.invalidLinkErrorMsg);
      return of(false);
    } else {
      if (!this.customerVerificationService.isVerified(+offerId, accessCode)) {
        return this.customerService.verifyAccessCodeCustomerOffer(+offerId, accessCode)
          .pipe(tap(verified => {
            if (!verified) {
              this.redirectUnauthorizePage(this.invalidCodeErrorMsg);
            }
          }));
      }
    }
    return of(true);
  }

  private redirectUnauthorizePage(errorMsg: string) {
    this.router.navigate(['/bestellung/unauthorized'], {
      state: { errorMsg }
    })
  }
}
